var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "w-full md:w-1/2 mb-16 px-6" }, [
    _c("div", { staticClass: "mb-2 flex" }, [
      _c("span", { staticClass: "w-1/2" }, [
        _c(
          "a",
          {
            attrs: { href: "#" },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.showResourceDetail.apply(null, arguments)
              },
            },
          },
          [_vm._v("Edit")]
        ),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "w-1/2 text-right" }, [
        _c(
          "a",
          {
            attrs: { href: "#" },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.deleteResource.apply(null, arguments)
              },
            },
          },
          [_vm._v("\n                Delete\n            ")]
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.resource.image
      ? _c("div", [
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.showResourceDetail.apply(null, arguments)
                },
              },
            },
            [
              _c("img", {
                attrs: {
                  src:
                    _vm.resource.image + "?auto=format&fit=crop&h=619&w=1024",
                },
              }),
            ]
          ),
        ])
      : _c("div", [
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.showResourceDetail.apply(null, arguments)
                },
              },
            },
            [
              _c("img", {
                attrs: { alt: "", src: "/img/hems-placeholder.png" },
              }),
            ]
          ),
        ]),
    _vm._v(" "),
    _vm.published
      ? _c("div", { staticClass: "uppercase text-base text-gray-darker" }, [
          _vm._v("Published"),
        ])
      : _c(
          "div",
          [
            _vm.status == "draft"
              ? [
                  _c("span", { staticClass: "text-red text-base uppercase" }, [
                    _vm._v("Draft"),
                  ]),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.status == "in review"
              ? [
                  _c("span", { staticClass: "text-red text-base uppercase" }, [
                    _vm._v("In Review"),
                  ]),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.status == "unpublished"
              ? [
                  _c("span", { staticClass: "text-red text-base uppercase" }, [
                    _vm._v("Unpublished"),
                  ]),
                ]
              : _vm._e(),
          ],
          2
        ),
    _vm._v(" "),
    _c("h2", { staticClass: "text-1xl leading-tight mb-2 mt-1" }, [
      _c(
        "a",
        {
          staticClass:
            "text-n-gray-dark font-sans no-underline hover:underline",
          attrs: { href: "#" },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.showResourceDetail.apply(null, arguments)
            },
          },
        },
        [_vm._v(_vm._s(_vm.resource.title) + "\n        ")]
      ),
    ]),
    _vm._v(" "),
    _vm.resource.organization
      ? _c("div", { staticClass: "font-sans-italic mb-1 hosted-by" }, [
          _c("span", { staticClass: "font-sans-bold-italic" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.resource.organization.name) +
                "\n        "
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", {
      staticClass: "text-base mb-5",
      domProps: { innerHTML: _vm._s(_vm.resource.teaser) },
    }),
    _vm._v(" "),
    _vm.resource.tags
      ? _c("div", {
          staticClass: "uppercase",
          domProps: { innerHTML: _vm._s(_vm.tagsHtml) },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }